<div class="page-wrap publicPage " [ngClass]="{'memberNews': onNewsPage}">
    <app-public-portal-header *ngIf="!hideHeader"></app-public-portal-header>
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <!-- <breadcrumb></breadcrumb> -->
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <div *ngIf="impersonating" class="impersonateBanner">
        <div class="d-flex align-items-center px-4 h-100">
            <h3 class="flex-grow-1 mb-0">
                <i class="fas fa-theater-masks"></i>
                <span>Impersonating: {{impersonatedContactName}}</span>
            </h3>
            <a class="ml-auto btn btn-outline-dark fw-bold" (click)="endImpersonation()" id="endImpersonate">
                <i class="far fa-stop-circle"></i> Stop Impersonating
            </a>
        </div>
    </div>
    <!-- ============================================================== -->
    <!-- <ams-action-items></ams-action-items> -->
    <router-outlet></router-outlet>
    <!-- ============================================================== -->
    <!-- End Start Page Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->

</div>
  <div class="d-flex align-items-center justify-content-center footerWrap" [ngClass]="{'d-none': onDirectory}">
      <section id="public-footer">
          <div class="text-center affPrefix">Built with <span class="cuteIcon mx-2"><i class="fa-solid fa-heart"></i></span> by</div>
          <a class="counterpartLink" href="https://www.counterpart.biz/" target="_blank"><img src="../../assets/images/logo/counterpart-blue.png" alt="Counterpart logo" /><span><i class="fa-regular fa-arrow-up-right-from-square"></i></span></a>
      </section>
	</div>